<template>
  <div class="box" :style="'top:' + boxPosition + '%'">
    <div class="introduction-img">
      <img :src="functionimage" alt="" />
    </div>

    <div class="round-box-outer">
      <div
        class="round-box-bg"
        :style="'background-image:url(' + bg + ')'"
      ></div>
      <div
        class="round-box"
        :class="activateBoxIndex === 0 ? 'activated' : ''"
        :style="activateBoxIndex === 0 ? shadow : ''"
      >
        <mall ref="mall"></mall>
        <div class="selected-module">
          <span
            v-for="(n, index) in menuList"
            :key="index"
            :class="activateBoxIndex === index ? 'activated1' : ''"
            @click="activateBoxIndex = index"
            >{{ n }}</span
          >
        </div>
      </div>
      <div
        class="round-box"
        :class="activateBoxIndex === 1 ? 'activated' : ''"
        :style="activateBoxIndex === 1 ? shadow : ''"
      >
        <market ref="market"></market>
        <div class="selected-module">
          <div class="fucmsg">
            <img :src="fucmsg" alt="" />
          </div>
          <span
            v-for="(n, index) in menuList"
            :key="index"
            :class="activateBoxIndex === index ? 'activated1' : ''"
            @click="activateBoxIndex = index"
            >{{ n }}</span
          >
        </div>
      </div>
      <div
        class="round-box"
        :class="activateBoxIndex === 2 ? 'activated' : ''"
        :style="activateBoxIndex === 2 ? shadow : ''"
      >
        <help ref="help"></help>
        <div class="selected-module">
          <span
            v-for="(n, index) in menuList"
            :key="index"
            :class="activateBoxIndex === index ? 'activated1' : ''"
            @click="activateBoxIndex = index"
            >{{ n }}</span
          >
        </div>
      </div>
      <!-- <div
        class="round-box"
        :class="activateBoxIndex === 3 ? 'activated' : ''"
        :style="activateBoxIndex === 3 ? shadow : ''"
      >
        <guide ref="guide"></guide>
        <div class="selected-module">
          <span
            v-for="(n, index) in menuList"
            :key="index"
            :class="activateBoxIndex === index ? 'activated1' : ''"
            @click="activateBoxIndex = index"
            >{{ n }}</span
          >
        </div>
      </div> -->
      <div
        class="round-box"
        :class="activateBoxIndex === 3 ? 'activated' : ''"
        :style="activateBoxIndex === 3 ? shadow : ''"
      >
        <tool ref="tool"></tool>
        <div class="selected-module">
          <span
            v-for="(n, index) in menuList"
            :key="index"
            :class="activateBoxIndex === index ? 'activated1' : ''"
            @click="activateBoxIndex = index"
            >{{ n }}</span
          >
        </div>
      </div>
    </div>
    <div class="bot-blue">
      <img :src="bottomblue" alt="" />
    </div>
  </div>
</template>
<script>
import market from "./round-spare-parts/flea_market";
import mall from "./round-spare-parts/mall";
import help from "./round-spare-parts/help";
import tool from "./round-spare-parts/tool";
import guide from "./round-spare-parts/guide";
import {
  roundSparePartsList,
  bgIcon,
  functionimage,
  bottomblue,
  fucmsg
} from "../../images/home/index";
// import { bgIcon } from "../../images/home/index";
// import { functionimage } from "../../images/home/index";
import bg from "../../images/home/introductions-bg.png";
export default {
  data() {
    return {
      boxPosition: "100",
      boxList: ["mall", "market", "help", "tool"],
      menuList: ["ECモール", "フリマ", "邦人NAVI", "ツール"],
      activateBoxIndex: 0,
      functionimage,
      shadow: null,
      roundSparePartsList,
      timer: null,
      icon: bgIcon,
      bg,
      isHasRun: false,
      bottomblue,
      fucmsg
    };
  },
  components: {
    mall,
    market,
    help,
    guide,
    tool
  },
  watch: {
    activateBoxIndex(n, o) {
      this.shadow = this.$refs[this.boxList[this.activateBoxIndex]].init(
        this.roundSparePartsList[this.boxList[this.activateBoxIndex]]
      );
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        // new slider({
        //   container: 'preview-slider',
        //   arrowLeft: 'arrow-left',
        //   arrowRight: 'arrow-right',
        //   vm: this
        // })
        if (!this.isHasRun) {
          this.shadow = this.$refs[this.boxList[this.activateBoxIndex]].init(
            this.roundSparePartsList[this.boxList[this.activateBoxIndex]]
          );
          // this.activateBoxIndexChange();
          this.isHasRun = true;
        }
      });
    },
    up() {
      this.boxPosition = "-100";
      clearInterval(this.timer);
    },
    die() {
      // clearInterval(this.timer)
    },
    // activateBoxIndexChange() {
    //   this.timer = setInterval(() => {
    //     this.$refs[this.boxList[this.activateBoxIndex]].back();
    //     this.activateBoxIndex += 1;
    //     if (this.activateBoxIndex === this.boxList.length) {
    //       this.activateBoxIndex = 0;
    //     }
    //   }, 10000);
    // },
    nomal() {
      this.boxPosition = "0";
      this.init();
    },
    down() {
      this.boxPosition = "100";
      clearInterval(this.timer);
    }
  }
};
</script>
<style scoped>
/* .box {
  background-image: url('../../images/home/introductions-bg0.png');
} */
.box {
  background-color: #fffcf7;
  z-index: 0;
}
.fucmsg {
  width: 0.55rem;
  position: absolute;
  top: -0.15rem;
  left: 5.4rem;
  z-index: 999;
}
.fucmsg img {
  width: 100%;
}
.bot-blue {
  width: 100%;
  height: 50%;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.bot-blue img {
  width: 100%;
}
.round-box-icon {
  position: absolute;
  right: -10rem;
  margin: auto;
  left: 0;
  bottom: 0;
  height: 2rem;
  width: 3rem;
  top: -5rem;
}
/* .box::before {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  content: "";
  top: 0;
  left: 0;
} */
.introduction-img img {
  display: block;
  width: 100%;
}
.introduction-img {
  text-align: center;
  width: 2.5rem;
  height: 1rem;
  position: absolute;
  top: 0.6rem;
  left: 50%;
  margin-left: -1.5rem;
  z-index: 99;
}
/* .introduction-title {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  width: 500px;
  position: relative;
  letter-spacing: 10px;
  margin: 0 auto;
  margin-top: 50px;
  line-height: 50px;
  height: 50px;
  color: rgba(7, 7, 7, 1);
  z-index: 1;
}
.introduction-title::before {
  content: "FUNCTION";
  color: rgba(49, 57, 80, 1);
  opacity: 0.1;
  position: absolute;
  width: 500px;
  text-align: center;
  left: 0;
  top: 0px;
  line-height: 30px;
  letter-spacing: 10px;
}
.introduction-title::after {
  content: "";
  width: 12px;
  height: 12px;
  position: absolute;
  top: 30px;
  left: 275px;
  background: rgba(219, 191, 42, 1);
  z-index: -1;
  opacity: 0.5;
} */
.box {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
.round-box-outer {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  top: 0;
}
.round-box-bg {
  width: 13rem;
  /* height: 6.2rem; */
  left: 0;
  right: 0;
  top: 2rem;
  box-sizing: border-box;
  border-radius: 0.1rem;
  position: absolute;
  margin: auto;
  background-position: center;
  background-size: 100% 100%;
  z-index: 0;
}

.round-box {
  width: 16rem;
  height: 7rem;
  box-sizing: border-box;
  border-radius: 0.3rem;
  overflow: hidden;
  position: absolute;
  top: 2rem;
  margin: 0 auto;
  z-index: 0;
  left: 0;
  right: 0;
  opacity: 0;

  transform-origin: 10rem 6.2rem;
  transition: all 0.5s;
}

.round-box.activated {
  z-index: 1;
  /* transform: rotate(0deg); */
  translate: 0px 0px;
  opacity: 1;
}
.selected-module {
  width: 13rem;
  position: absolute;
  left: 7%;

  top: 0.2rem;
  margin: 0 auto;
  height: 0.3rem;
  text-align: center;
  display: flex;
  justify-content: space-around;
  z-index: 22;
}
.selected-module span {
  /* display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ddd;
  margin-top: 20px;
  transition: all 0.5s; */
  cursor: pointer;
  font-size: 0.2rem;
  display: inline-block;
  width: 1.4rem;
  height: 0.4rem;
  line-height: 0.4rem;
  border-radius: 0.1rem;
}
.selected-module span.activated1 {
  background: #ffdf34;
}
.selected-module span.activated2 {
  background: rgba(25, 169, 109, 1);
}
.selected-module span.activated3 {
  background: rgba(241, 108, 61, 1);
}
.selected-module span.activated4 {
  background: rgba(227, 155, 247, 1);
}
.selected-module span.activated5 {
  background: rgba(74, 97, 251, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/home/modules/function-introduction.vue